var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueGallery',{attrs:{"images":_vm.images,"index":_vm.index},on:{"slide":_vm.onGalleryThumb,"close":_vm.onGalleryClose}})
}
var staticRenderFns = []

export { render, staticRenderFns }